import {LogLevel} from "angular-auth-oidc-client";
import {Environment} from "./environment-model";

// DEV Environment
export const environment: Environment = {
  baseUrl: "/",
  endpoint: "/api/",
  apiGateway: "https://api-s.trumpf.com",
  apiGatewayHeader: 'wso2amsf',
  apiVersion: "1.0",
  featureToggleApiUrl: "https://cms/api/default",
  authConfig: {
    authority: "https://account-s.trumpf.com/vforcesite/services/oauth2",
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: "3MVG9vE7x_jtom6Y6lse7GE.fT9Kv6Us.QkI39TaPBdR.enNAZvAaE5QuyTtWD8FKdLUjLpUT0ScyFQWV3JvW",
    scope: "openid profile offline_access refresh_token",
    responseType: "code",
    silentRenew: true,
    useRefreshToken: true,
    silentRenewUrl: window.location.origin + "/silent-renew.html",
    renewTimeBeforeTokenExpiresInSeconds: 60,
    authWellknownEndpointUrl: "https://account-s.trumpf.com/.well-known/openid-configuration",
    logLevel: LogLevel.None,
    secureRoutes: ["https://api-s.trumpf.com/", "https://app-tf-trumpf-tw200-cam-dev.azurewebsites.net"]
  },
  userGroupName: "ROLE_MYT_Cockpit_DEV_User",
  adminGroupName: "ROLE_MYT_Cockpit_DEV_Admin"
};
